<template>
	<div v-if="errorCode" class="fraud-errors">
		<div v-if="errorTitle" class="fraud-errors__title">{{ errorTitle }}</div>
		<div class="fraud-errors__description">
			{{ errorMessage }}
		</div>

		<i18n class="fraud-errors__support" path="checkout.need-help" tag="div">
			<template v-slot:supportLink>
				<a v-t="'checkout.support-link-text'" :href="supportLink" target="_blank" @click="onSupportClick"></a>
			</template>
		</i18n>
		<div class="fraud-errors__action">
			<FormButton :label="$t('checkout.back-payment-methods')" :button-click="backToPayments"></FormButton>
		</div>
	</div>
</template>

<script>
import { FormButton } from '@arena/toolkit';
import links from '@/config/links';

export default {
	name: 'FraudErrors',
	components: {
		FormButton,
	},
	data() {
		return {};
	},
	computed: {
		errorCode() {
			return this.$store.state.selectedPgErrorCode;
		},
		supportLink() {
			return links[this.region].supportLink;
		},
		errorTitle() {
			switch (this.errorCode) {
				case '002-400-0005':
				case '002-400-0006':
				case '002-400-0010':
					return this.$t('checkout.purchase-failed');
				case '002-400-0007':
					return this.$t('checkout.currently-under-review');
				case '002-400-0008':
					return this.$t('checkout.still-under-review');
				default:
					return '';
			}
		},
		errorMessage() {
			switch (this.errorCode) {
				case '002-400-0005':
				case '002-400-0006':
				case '002-400-0010':
					return `${this.$t(`error.form.${this.errorCode}`)} (${this.errorCode})`;
				case '002-400-0007':
				case '002-400-0008':
					return this.$t('checkout.under-review-details');
				default:
					return '';
			}
		},
		pgClicked() {
			return this.$store.state.pgClicked;
		},
		selectedPg() {
			return this.$store.state.selectedPg;
		},
		isIngamePurchase() {
			return this.$route.name === 'in-game-purchase' || this.$store.state.appType === 'game';
		},
	},
	mounted() {
		this.$a2s.view('error_imp', {
			name: 'error_code',
			value: this.errorCode,
			objectTag: 'purchase_error',
		});
		dataLayer.push({
			event: `${this.isIngamePurchase ? 'In Game' : 'Add Balance'} Credit Unavailable`,
			'Returning Check': this.pgClicked ? 'Manual' : 'Automatic',
			'Payment Gateway': this.selectedPg && this.selectedPg.methodName ? this.selectedPg.methodName : '',
			'PG Type': this.selectedPg && this.selectedPg.isRefundable ? 'Credit' : 'PrePaid',
		});
	},
	methods: {
		backToPayments() {
			this.$a2s.click('error_close');
			// removing fraud error code and return to the payment methos
			this.$store.commit('setSelectedPgErrorCode', null);
			this.$store.commit('setSelectedPg', null);
			this.$store.commit('setShowSelectedPg', false);
		},
		onSupportClick() {
			this.$a2s.click('error_support');
		},
	},
};
</script>

<style lang="less" scoped>
.fraud-errors {
	text-align: center;
	padding-left: 34px;
	padding-right: 34px;
	&__title {
		font-size: 16px;
		font-weight: 700;
		color: #fff;
		padding-top: 15px;
	}
	&__description {
		line-height: 1.2;
		padding-top: 11px;
	}
	&__details {
		margin-top: 10px;
		line-height: 1.2;
	}
	&__support {
		font-size: 14px;
		margin-top: 6px;
		padding-top: 6px;
		a {
			color: inherit;
			text-transform: capitalize;
			text-decoration: underline;
			text-underline-position: under;
			&:hover {
				color: #fff;
			}
		}
	}
	&__action {
		button {
			display: inline;
			width: auto;
			min-width: 300px;
			border-radius: 2px;
		}
	}
}

@media (max-width: 599px) {
	.fraud-errors {
		padding-left: 0;
		padding-right: 0;
		&__title {
			padding-top: 0;
		}
		&__description {
			font-size: 14px;
		}
		&__support {
			margin-top: 6px;
			padding-top: 6px;
		}
		&__action {
			button {
				width: 100%;
				min-width: 100%;
			}
		}
	}
}
</style>
